<div
  class="form-group"
  [ngClass]="{
    'has-error has-danger':
      ngControl.touched && !ngControl.valid && !ngControl.disabled,
    'has-success': ngControl.touched && ngControl.valid
  }"
>
  <label class="form-control-label" [for]="identifier">{{ labelText }}</label>
  <select
    [id]="identifier"
    [name]="name"
    class="form-control"
    [ngClass]="hasRequiredError() ? 'is-invalid' : touched ? 'is-valid' : ''"
    [(ngModel)]="value"
    [required]="required == 'true' || required == '' ? '' : undefined"
    #control="ngModel"
    (change)="selectedChange($event)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [attr.aria-required]="isRequired"
    [attr.aria-describedby]="isShowErrors ? identifier + '-feedbacks' : null"
  >
    <option *ngIf="withNull" value=""></option>
    <option *ngFor="let option of options" [ngValue]="option[optionValue]">
      {{ option[optionText] }}
    </option>
  </select>
  <small
    [id]="identifier + 'Help'"
    *ngIf="helpText"
    class="form-text text-muted"
  >
    {{ helpText }}</small
  >

  <ng-container *ngTemplateOutlet="feedback"> </ng-container>
</div>

<ng-template #feedback>
  <ng-container *ngIf="isShowErrors">
    <div [id]="identifier + '-feedbacks'" class="invalid-feedback" role="alert">
      <div
        *ngFor="let error of errors; trackBy: trackByMessageKey"
        [innerText]="
          key + '.' + error.messageKey | translate : error.messageArgs
        "
      ></div>
    </div>
  </ng-container>
</ng-template>
